import Vue from 'vue';
import Rsa from './Rsa';
import gloabaleConfig from './globalConfig';
import formatDate from './formatDate';
const rsa = new Rsa();
const mainHost = gloabaleConfig.getMainHost();
export const EventBus = new Vue();
export let convertParamToString = function (params) {
  var paramArray = [];
  for (var key in params) {
    var val = params[key];
    if (typeof val === 'object') {
      val = JSON.stringify(val);
    }
    var param = key + '=' + val;
    paramArray.push(param);
  }
  paramArray.push('callback');
  if (paramArray.length > 0) {
    return paramArray.join('&');
  }
  return '';
};

export function b64DecodeUnicode(str) {
  return decodeURIComponent(
    atob(str)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );
}

export function b64EncodeUnicode(str) {
  return btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
      return String.fromCharCode('0x' + p1);
    })
  );
}

export const encryption = function (text) {
  // todo encryption the text
  return rsa.encode(text);
  // return text;
};

// 统计接口,config格式如下：
// {
//     id: 1,
//     la: '帐号',
//     gid: '游戏ID',
//     ext: 1, // 浮层数据
//     e1: '功能类型',
//     e2: '功能名称'
// }
export const statsRequest = function (config) {
  let img = new Image();
  let statsUrl = `//gcollectdata.${mainHost}/ps.gif?`;
  let param = '';
  let createParams = config => {
    for (var i in config) {
      param += i + '=' + config[i] + '&';
    }
  };
  Object.prototype.toString.call(config) !== '[object Object]'
    ? console.log(
      'Error! statsReq config is not a object! The value is ' + config
    )
    : createParams(config);
  img.src = statsUrl + param;
};

export const SOUTHEST_ASIA_MODE = 1;
export const WESTTERN_MODE = 2;

const MAIN_HOST = gloabaleConfig.getMainHost();
export const EXCHANGE_URL = `//gevents.${mainHost}/globalexchange/indexm.html`;
export const FEEKBACK_URL = `//service.${MAIN_HOST}`;
export const SERVICE_TERM_URL = `//gpassport.${MAIN_HOST}/center/servicePrivicy/service`;
export const PRIVICY_TERM_URL = `//gpassport.${MAIN_HOST}/center/servicePrivicy/privicy`;
export const STORE_PAGE_BASE_URL = `//pay.${MAIN_HOST}`;
export const RES_HOST = `//gabres.${MAIN_HOST}/`; // 这里记得恢复回去
// export const RES_HOST = `//abres.octlib.com/`; // 这里记得恢复回去
export const PAYTYPE_ICON_URL = `//cdnimages.awselbcombine.com/public_images/paytype_ext/`;

export const renderGoogleRecaptcha = function (id, key) {
  if (window.grecaptcha.render) {
    window.grecaptcha.render(id, {
      sitekey: key,
      callback: 'onSubmit'
    });
  } else {
    window.recaptchaOnload = () => {
      window.grecaptcha.render(id, {
        sitekey: key,
        callback: 'onSubmit'
      });
    };
  }
};

export const submitGoogleRecaptcha = function (callback) {
  window.onSubmit = token => {
    window.grecaptcha.reset();
    if (callback instanceof Function) {
      callback(token);
    }
  };
};

export let changePriceFormat = function (currency, amount) {
  let price = amount;
  if (currency === 'VND') {
    price = parseInt(amount.replace(/\.\d{2}$/, ''));
    price = price.toLocaleString('vi-VN') + '';
  }
  return price;
};

export const injectScript = function (scriptPath, callback) {
  var scriptNode = document.createElement('SCRIPT');
  scriptNode.type = 'text/javascript';
  scriptNode.src = scriptPath;

  var headNode = document.getElementsByTagName('head');
  if (headNode[0] != null) headNode[0].appendChild(scriptNode);
  if (callback != null) {
    scriptNode.onreadystagechange = callback;
    scriptNode.onload = callback;
  }
};

export const replaceDateAndPricesOfText = ({ date, prices, text }) => {
  let newDate = formatDate(new Date(date.replace(/-/g, '/')), 'yyyy-MM-dd');
  const [year, month, day] = newDate.split('-');
  let newText = text
    .replace('${year}', year)
    .replace('${month}', month)
    .replace('${day}', day);

  if (prices) {
    newText = newText.replace('${prices}', prices);
  }
  return newText;
};

/**
 *  判断是否是函数
 * @param {*} obj 要判断的对象
 * @returns
 */
export const isFn = obj => {
  return Object.prototype.toString.call(obj) === '[object Function]';
};

/**
 * 判断两个window.location.origin是否是同一个主域
 * @param {*} h1 域名1
 * @param {*} h2 域名2
 * @returns
 */
export const judgeIsSameMainHost = (h1, h2) => {
  let h1MainHostMatch = h1.match(/.\w*.\w*$/);
  let h2MainHostMatch = h2.match(/.\w*.\w*$/);
  if (
    h1MainHostMatch &&
    h2MainHostMatch &&
    h1MainHostMatch[0] &&
    h2MainHostMatch[0]
  ) {
    return h1MainHostMatch[0] == h2MainHostMatch[0];
  } else {
    return false;
  }
};

// 获取页面加载类型
export const getPageLoadType = () => {
  if (
    !performance ||
    typeof performance === 'undefined' ||
    typeof performance.getEntriesByType !== 'function'
  ) {
    return 'unavailable';
  }

  const navigationEntries = performance.getEntriesByType('navigation');
  if (!Array.isArray(navigationEntries) || navigationEntries.length === 0) {
    return 'unknown';
  }

  const navigationType = navigationEntries[0].type;
  const typeMap = new Map([
    ['navigate', 'navigate'],
    ['reload', 'reload'],
    ['back_forward', 'back_forward']
  ]);

  return typeMap.get(navigationType) || 'unknown';
};

export const isNumber = str => {
  const regx = /^\d+$/;
  return regx.test(str);
};

// 获取当前页面的cid，替换链接中的cid，返回新的链接
export const replaceCidByPageCid = url => {
  if (!url) {
    return '';
  }
  // 获取页面的cid
  const pageCid = gloabaleConfig.getHrefParam('cid') || 'web';
  // 检查是否有协议，如果没有添加默认协议。如果没有协议new URL会有故障但是不报错
  const hasProtocol = url.startsWith('http:') || url.startsWith('https:');
  const urlWithProtocol = hasProtocol ? url : 'https:' + url;
  let curUrl = new URL(urlWithProtocol);
  let params = new URLSearchParams(curUrl.search);
  // 设置新的参数值，如果参数不存在则会添加
  params.set('cid', pageCid);
  curUrl.search = params.toString();
  const newUrl = curUrl.toString();
  // 返回新的 URL
  return hasProtocol ? newUrl : newUrl.replace(/^https:/, '');
};

export const getStoreUrlParams = () => {
  try {
    if (window.location.hash === '#/result') {
      const store_url_params = decodeURIComponent(
        gloabaleConfig.getHrefParam('store_url_params').replace('#/result', '')
      );
      const storeParams = b64DecodeUnicode(store_url_params);
      return JSON.parse(storeParams);
    } else {
      return {};
    }
  } catch (e) {
    console.error(e);
  }
  return {};
}

/**
 * 获取文件扩展名
 * @param {*} file 文件对象
 * @returns {string} 文件扩展名，如 'jpg', 'png', 'mp4' 等
 */
export const getFileExtension = file => {
  // 方法1：从文件名中获取扩展名
  const fileNameExt = file.name ? file.name.split('.').pop().toLowerCase() : '';
  
  // 方法2：从 MIME 类型中获取扩展名
  const mimeTypeExt = file.type ? file.type.split('/').pop().toLowerCase() : '';
  
  // 优先使用文件名中的扩展名，如果没有则使用 MIME 类型
  const extension = fileNameExt || mimeTypeExt;
  
  return extension;
};
